import { MotionGroup, MotionItem, MotionReveal, MotionText } from "../components/MotionReveal";
import roadImage from "../assets/road construction.jpg";

export const homeAboutStats = [
  { value: "10", label: "Service areas" },
  { value: "11+", label: "Years of experience" },
  { value: "120+", label: "Featured projects" },
  { value: "100%", label: "Client commitment" },
];

export default function HomeAboutSection() {
  return (
    <section className="tgm-section tgm-home-about">
      <div className="container">
        <MotionGroup className="tgm-editorial-head" stagger={0.08}>
          <div>
            <MotionReveal
              as="p"
              className="tgm-editorial-kicker"
              variant="soft"
            >
              About Us
            </MotionReveal>
            <MotionText as="h2" text="Innovative Development Infrastructure" />
          </div>
        </MotionGroup>

        <MotionReveal className="tgm-home-about-image" variant="image">
          <img src={roadImage} alt="SNJ Tanzania construction works" />
        </MotionReveal>

        <MotionReveal as="p" className="tgm-home-about-copy" variant="soft">
          SNJ Tanzania Limited is a civil and building contractor supporting
          clients through planning, execution, supervision, and commissioning.
          The company focuses on clear communication, quality control, and
          practical construction solutions for small to medium-size projects.
        </MotionReveal>

        <MotionGroup className="tgm-home-stat-grid" stagger={0.08}>
          {homeAboutStats.map((stat) => (
            <MotionItem className="tgm-home-stat" variant="card" key={stat.label}>
              <strong>{stat.value}</strong>
              <span>{stat.label}</span>
            </MotionItem>
          ))}
        </MotionGroup>
      </div>
    </section>
  );
}
